import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { CssBaseline, ThemeProvider } from '@mui/material';

import theme from 'Lib/theme';
import { initializeSentry } from 'Lib/utilities/sentryUtils';

import App from './containers/App';
import store from './store';

import './tailwind.css';

initializeSentry();

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Workaround for https://github.com/facebook/react/issues/11538
if (typeof Node === 'function' && Node.prototype) {
	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function (child) {
		if (child.parentNode !== this) {
			if (console) {
				console.error('Cannot remove a child from a different parent', child, this);
			}

			return child;
		}

		return originalRemoveChild.apply(this, arguments);
	};

	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function (newNode, referenceNode) {
		if (referenceNode && referenceNode.parentNode !== this) {
			if (console) {
				console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
			}

			return newNode;
		}

		return originalInsertBefore.apply(this, arguments);
	};
}

root.render(
	<Provider store={store}>
		<ThemeProvider theme={theme}>
			<CssBaseline enableColorScheme />
			<App />
		</ThemeProvider>
	</Provider>
);
